// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"d26f7e63","168":"68c946b8"}[chunkId] + ".chunk.css";
};